<div class="body">
  @if (detalleSolcitud) {
    <div class="container pt-3 pb-3">
      <div class="title-box mb-3">
        <h1>Crear oferta de crédito <span class="sub-2">Aliado Financiero</span></h1>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 text-start">
          <h5>INFORMACIÓN DE LA SOLICITUD</h5>
        </div>
      </div>
      <div class="row justify-content-md-center mt-4">
        <div class="col-12 col-sm-3">
          <div class="header-inf">
            No. de Solicitud
          </div>
          <p>{{detalleSolcitud.solicitud.idSolicitud}}</p>
        </div>
        <div class="col-12 col-sm-6">
          <div class="header-inf">
            Nombre del solicitante
          </div>
          <p>{{detalleSolcitud.empresario.primerNombre}} {{detalleSolcitud.empresario.primerApellido}}
          </p>
        </div>
        <div class="col-12 col-sm-3">
          <div class="header-inf">
            Monto solicitado
          </div>
          <p>{{detalleSolcitud.solicitud.monto | currency:'USD' : 'symbol' : '1.0-0'}}</p>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-3">
          <div class="header-inf">
            Tipo de Identificación
          </div>
          @if (detalleSolcitud.empresario.idTipoDocIdentidad_NeoTipoDocIdentidad == 1) {
            <p>NIT</p>
          }
          @if (detalleSolcitud.empresario.idTipoDocIdentidad_NeoTipoDocIdentidad == 2) {
            <p>CÉDULA DE
            CIUDADANÍA</p>
          }
          @if (detalleSolcitud.empresario.idTipoDocIdentidad_NeoTipoDocIdentidad == 3) {
            <p>CÉDULA DE
            EXTRANJERÍA</p>
          }
          @if (detalleSolcitud.empresario.idTipoDocIdentidad_NeoTipoDocIdentidad == 4) {
            <p>TARJETA DE
            IDENTIDAD</p>
          }
          @if (detalleSolcitud.empresario.idTipoDocIdentidad_NeoTipoDocIdentidad == 5) {
            <p>PASAPORTE
            </p>
          }
          @if (detalleSolcitud.empresario.idTipoDocIdentidad_NeoTipoDocIdentidad == 6) {
            <p>NÚMERO
            ÚNICO DE IDENTIFICACIÓN</p>
          }
        </div>
        <div class="col-12 col-sm-6">
          <div class="header-inf">
            Número de identificación
          </div>
          <p>{{detalleSolcitud.empresario.numeroDocumento}}</p>
        </div>
        <div class="col-12 col-sm-3">
          <div class="header-inf">
            Plazo solicitado (meses)
          </div>
          <p>{{detalleSolcitud.solicitud.plazo}}</p>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-12">
          <div class="header-inf">
            Destino del crédito
          </div>
          <p>{{detalleSolcitud.solicitud.destino}}</p>
        </div>
      </div>
      @if (detalleSolcitud.observacionAprobadorParaRevisor != null) {
        <div class="row justify-content-md-center">
          <div class="col-12 col-sm-8">
            <label for="observaciones" class="form-label">Observaciones del motivo devolución de oferta del aprobador:</label>
            <textarea class="form-control" style="height: 100px;"
            [disabled]="true">{{ detalleSolcitud.observacionAprobadorParaRevisor }}</textarea>
          </div>
        </div>
      }
      <div class="row justify-content-md-center mt-5">
        <div class="col-12 col-sm-6">
          <p>Seleccione el origen de los recursos para diligenciar la oferta.</p>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="mb-3 col-12 col-sm-6">
          <select class="form-control" data-width="100%" name="origenRec" #origenRec="ngModel"
            [(ngModel)]="origenRecursos" (change)="cargarLineas($event.target.value)"
            title="Seleccione una opción">
            <option value="null" selected disabled>Seleccione una opción</option>
            @if (idCupoBancoldex == 0 && idCupoBancoldexVerificado==0) {
              <option value="Propios">Propios</option>
            } @else {
              @if (idCupoBancoldex == 1 &&
                idCupoBancoldexVerificado==1;) {
                <option value="Bancoldex">Bancóldex</option>
              }
              <option value="Propios">Propios</option>
            }
          </select>
        </div>
      </div>
      <div class="row mt-3 justify-content-md-center">
        @if (origenRecursos==null || origenRecursos=='null') {
          <div class="mb-3 col-12 col-sm-6"
            >
            <button class="btn btn-primary" (click)="goBack()">Volver</button>
          </div>
        }
      </div>
      @if (origenRecursos=='Bancoldex') {
        <form action="" id="formulario-bancoldex" class="mt-4">
          <div class="row">
            <div class="col-12 col-sm-12">
              <h5>PARÁMETROS DE LA OFERTA</h5>
            </div>
          </div>
          <div class="row">
            <div class="mb-3 col-12 col-sm-12 text-start">
              <p>Línea de crédito*</p>
              <select class="selectpicker" data-size="6" data-live-search="true" data-width="100%"
                name="lineaCreditoBancoldex"
                [(ngModel)]="neoPropuestaIntermediarioBancoldex.propuesta.idLineaBancoldex" required
                (change)="cargarDestinosModalidadBancoldex($event.target.value)"
                title="Seleccione una opción">
                @for (linea of lineasBancoldex; track linea) {
                  <option [(value)]="linea.idModalidad">
                  {{linea.nombreModalidad}}</option>
                }
              </select>
            </div>
          </div>
          <div class="row">
            <div class="mb-3 col-12 col-sm-12 col-lg-6 text-start">
              <p>Sucursal*</p>
              <select class="selectpicker" data-size="6" data-live-search="true" data-width="100%"
                name="idSucursalBancoldex"
                [(ngModel)]="neoPropuestaIntermediarioBancoldex.propuesta.idSucursal" required
                title="Seleccione una opción">
                @for (sucursal of sucursalesBancoldex; track sucursal) {
                  <option [(value)]="sucursal.idSucursal">
                  {{sucursal.nombreSucursal}}</option>
                }
              </select>
            </div>
            <div class="mb-3 col-12 col-sm-12 col-lg-6 text-start">
              <p>Destino*</p>
              <select type="number" class="selectpicker" data-size="6" data-live-search="true"
                data-width="100%" name="destinoBancoldex"
                [(ngModel)]="neoPropuestaIntermediarioBancoldex.propuesta.idDestino" required
                (change)="cargarDatosModalidadXDestinoBancoldex($event.target.value)"
                title="Seleccione una opción">
                @for (destino of destinosBancoldex; track destino) {
                  <option [(value)]="destino.idDestino">
                  {{destino.nombreDestino}}</option>
                }
              </select>
            </div>
          </div>
          <div class="row mt-3 text-start justify-content-md-center">
            <div class="col-12 col-sm-5">
              <p>Monto*</p>
              <div class="input-group">
                <span class="input-group-text">$</span>
                <input class="form-control" type="text"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" maxlength="17"
                  id="montoBx" (keypress)="setPipeMontoBx()" name="montoBancoldex"
                  (blur)="calcularCuotaBancoldex()" [(ngModel)]="montoBancoldex" required>
                </div>
              </div>
              <div class="col-12 col-sm-2"></div>
              <div class="mb-3 col-12 col-sm-5">
                <p>Plazo en meses*</p>
                <select class="selectpicker" data-live-search="true" data-size="6" data-width="100%" name="plazoBancoldex"
                  [(ngModel)]="neoPropuestaIntermediarioBancoldex.propuesta.plazo" required
                  (change)="calcularCuotaBancoldex();cargarTasasRedescuento()"
                  title="Seleccione una opción">
                  <option value="{{0}}" disabled>Seleccione una opción</option>
                  @for (plazoLinea of plazosLineaBancoldex; track plazoLinea) {
                    <option [(value)]="plazoLinea.plazo">
                    {{plazoLinea.descripcion}}</option>
                  }
                </select>
              </div>
            </div>
            <div class="row mt-3 text-start justify-content-md-center">
              <div class="col-12 col-sm-4">
                <p>Tasa Bancóldex EA*</p>
                <input type="text" [disabled]="true" name="tasaRedescuentoEA"
                  [(ngModel)]="tasaRedescuentoEABancoldex" required>
                </div>
                <div class="col-12 col-sm-4">
                  <p>Margen de intermediación*</p>
                  <div class="input-group">
                    <span class="input-group-text">%</span>
                    <input type="text" class="form-control"
                      onkeypress="return (event.charCode >= 48 && event.charCode <= 57 || event.charCode==46)"
                      maxlength="6" (blur)="calcularTasaTotal()" name="margenIntermediario"
                      [(ngModel)]="neoPropuestaIntermediarioBancoldex.propuesta.margenIntermediario"
                      required>
                    </div>
                  </div>
                  <div class="col-12 col-sm-4">
                    <p>Tasa EA*</p>
                    <div class="input-group">
                      <span class="input-group-text">%</span>
                      <input type="number" class="form-control" [disabled]="true" name="tasaTotalEA"
                        [(ngModel)]="neoPropuestaIntermediarioBancoldex.propuesta.tasa" required>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3 text-start justify-content-md-center">
                    <div class="mb-3 col-12 col-sm-5">
                      <p>Periodicidad de pago de capital e intereses*</p>
                      <select class="selectpicker" data-live-search="true" data-size="6" data-width="100%" name="periodicidadBancoldex"
                        [(ngModel)]="neoPropuestaIntermediarioBancoldex.propuesta.periodicidad" required
                        (change)="calcularCuotaBancoldex()" title="Seleccione una opción">
                        @for (periodicidad of periodicidadesBancoldex; track periodicidad) {
                          <option value="{{periodicidad.idTipoPeriodicidad}}"
                            >{{periodicidad.periodicidadPago}}
                          </option>
                        }
                      </select>
                    </div>
                    <div class="col-12 col-sm-2"></div>
                    <div class="mb-3 col-12 col-sm-5">
                      <p>Período de gracia</p>
                      <select class="selectpicker" data-live-search="true" data-size="6" data-width="100%" name="periodoBancoldex"
                        [(ngModel)]="neoPropuestaIntermediarioBancoldex.propuesta.periodoGracia" required
                        title="Seleccione una opción">
                        <option value="{{0}}" disabled>Seleccione una opción</option>
                        @for (periodo of periodosGraciaBancoldex; track periodo) {
                          <option value="{{periodo.plazo}}">
                          {{periodo.descripcion}}</option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="row mt-3 text-center justify-content-md-center">
                    <div class="col-12 col-sm-4 align-self-center">
                      <div class="col-12 col-sm-12 box">
                        <span
                          class="number-value">{{neoPropuestaIntermediarioBancoldex.propuesta.desembolsoAproximado
                        | currency:'USD' : 'symbol' : '1.0-0'}}</span>
                        <p>Valor de oferta</p>
                      </div>
                      <div class="col-12 col-sm-12 box">
                        <span class="number-value">{{neoPropuestaIntermediarioBancoldex.propuesta.cuota |
                        currency:'USD' : 'symbol' : '1.0-0'}}</span>
                        <p>Valor cuota</p>
                      </div>
                      <div class="col-12 col-sm-12 mt-4">
                        <button type="button" class="btn btn-primary" (click)="downloadAll()">Revisar
                        documentación</button>
                        <a id="allFile" style="display: none;"></a>
                      </div>
                    </div>
                    <div class="col-12 col-sm-8">
                      <div class="col-12 col-sm-12">
                        <!-- <form> -->
                        <div class="row justify-content-md-center mt-4">
                          <h4>OTROS CARGOS Y/O GARANTÍAS</h4>
                        </div>
                        <div class="row mt-2">
                          @if (tiposCondicion.length == 0) {
                            <div class="col-12 col-sm-5">
                              Nombre Cargo y/o Garantías
                              <input type="text" maxlength="100" name="propiosBancoldex"
                                [(ngModel)]="cargoGarantiasBancoldexNuevo.descripcion">
                              </div>
                            }
                            @if (tiposCondicion.length > 0) {
                              <div class="mb-3 col-12 col-sm-5">
                                Nombre Cargo y/o Garantías
                                <select class="selectpicker" data-live-search="true" data-size="6" data-width="100%" name="propiosBancoldex"
                                  [(ngModel)]="cargoGarantiasBancoldexNuevo.idParametrizacionCondicion"
                                  title="Seleccione una opción">
                                  @for (tipoCondicion of tiposCondicion; track tipoCondicion) {
                                    <option [(value)]="tipoCondicion.idParametrizacionCondicion"
                                    >{{tipoCondicion.nombre}}</option>
                                  }
                                </select>
                              </div>
                            }
                            <div class="col-12 col-sm-3">
                              Valor
                              <input type="text"
                                onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" maxlength="17"
                                id="montoGarantiaBx" (keypress)="setPipeMontoGarantiaBx()"
                                name="montoCargoGarantiaBancoldexNuevo"
                                [(ngModel)]="cargoGarantiasBancoldexNuevo.monto">
                              </div>
                              <div class="mb-3 col-12 col-sm-4">
                                Tipos de cargos y/o garantías
                                <select class="selectpicker" data-size="6" data-width="100%"
                                  name="idTipoCargoGarantiaBancoldexNuevo"
                                  [(ngModel)]="cargoGarantiasBancoldexNuevo.idTipoCargo_NeoTipoCargo"
                                  title="Seleccione una opción">
                                  @for (tipoCargo of tiposCargo; track tipoCargo) {
                                    <option [(value)]="tipoCargo.idTipoCargo">
                                    {{tipoCargo.nombre}}</option>
                                  }
                                </select>
                              </div>
                            </div>
                            <div class="row justify-content-md-center mt-3">
                              <div class="col-12 col-sm-6">
                                <button type="button" class="btn btn-primary"
                                  [disabled]="!habilitarCargosGarantiasBancoldex"
                                  (click)="agregarCargosGarantiasLineaBancoldex()">Agregar cargos y/o
                                garantías</button>
                              </div>
                            </div>
                          </div>
                          <div class="row col-12 col-sm-12 mt-4">
                            <div class="table-responsive">
                              <table class="table table-striped table-borderless rounded">
                                <thead class="table_head">
                                  <tr>
                                    <th scope="col" class="no-styles table-header">Nombre de cargos y/o garantías
                                    </th>
                                    <th scope="col" class="no-styles table-header">Valor</th>
                                    <th scope="col" class="no-styles table-header">Tipo de cargo y/o garantías</th>
                                    <th scope="col" class="no-styles table-header">Acción</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  @for (cargoGarantia of cargosGarantiasLineaBancoldexConNombre; track cargoGarantia; let i = $index) {
                                    <tr
                                      >
                                      @if (tiposCondicion.length == 0) {
                                        <th scope="row">{{cargoGarantia.descripcion}}
                                        </th>
                                      }
                                      @if (tiposCondicion.length > 0) {
                                        <th scope="row">{{cargoGarantia.descripcion}}
                                        </th>
                                      }
                                      <td>{{cargoGarantia.monto | currency:'USD' : 'symbol' : '1.0-0'}}</td>
                                      <td>{{cargoGarantia.nombreTipoCargo}}</td>
                                      <td><button type="button" class="btn btn-danger"
                                        (click)="borrarCargosGarantiasLineaBancoldex(i)"><i
                                      class="fas fa-trash-alt"></i></button></td>
                                    </tr>
                                  }
                                </tbody>
                              </table>
                            </div>
                          </div>
                          @if (aprobarBancoldex) {
                            <div class="col-12 col-sm-12 mt-2" class="text-start justify-content-start"
                              >
                              <p>Observaciones</p>
                              <textarea name="observacionesBancoldex"
                                [(ngModel)]="neoPropuestaIntermediarioBancoldex.propuesta.observaciones" id=""
                              cols="80" rows="3"></textarea>
                            </div>
                          }
                        </div>
                      </div>
                    </form>
                  }
                  @if (observacionesAprobadorBancoldex) {
                    <div class="row justify-content-md-center">
                      <div class="col-12 col-sm-12 mt-4 justify-content-md-center">
                        <p>Observaciones aprobador</p>
                        <textarea name="" id="" [disabled]="true" cols="80" rows="3" name="observaciones"
                        [(ngModel)]="observacionesAprobadorBancoldex"></textarea>
                      </div>
                    </div>
                  }
                  @if (origenRecursos=='Bancoldex') {
                    <div class="row justify-content-md-center mt-3">
                      @if (!aprobarBancoldex) {
                        <div class="col-12 col-sm-2 mt-4">
                          <button type="button" class="btn btn-primary" (click)="anterior()">Anterior</button>
                        </div>
                      }
                      @if (aprobarBancoldex && detalleSolcitud.observacionAprobadorParaRevisor == null) {
                        <div class="col-12 col-sm-2 mt-4">
                          <button type="button" class="btn btn-primary"
                          (click)="anteriorBancoldex2()">Anterior</button>
                        </div>
                      }
                      <div class="col-12 col-sm-2 mt-4">
                        @if (detalleSolcitud.observacionAprobadorParaRevisor != null) {
                          <button type="button" class="btn btn-primary"
                          (click)="goBack()">Volver</button>
                        }
                      </div>
                      @if (!aprobarBancoldex) {
                        <div class="col-12 col-sm-2 mt-4">
                          <button type="button" class="btn btn-primary" (click)="siguienteBancoldex()"
                          [disabled]="!habilitarCargosGarantiasBancoldex">Siguiente</button>
                        </div>
                      }
                      @if (aprobarBancoldex) {
                        <div class="col-12 col-sm-2 mt-4">
                          <button type="button" class="btn btn-primary"
                          (click)="aprobarSolicitudRecBancoldex()">Aprobar</button>
                        </div>
                      }
                    </div>
                  }
                  @if (origenRecursos=='Propios') {
                    <form action="" id="formulario-propios" class="mt-4">
                      <div class="row">
                        <div class="col-12 col-sm-12">
                          <h5>PARÁMETROS DE LA OFERTA</h5>
                        </div>
                      </div>
                      <div class="row">
                        <div class="mb-3 col-12 col-sm-12 text-start">
                          <p>Línea de crédito*</p>
                          <select class="selectpicker" data-live-search="true" data-size="6" data-width="100%" name="lineaCreditoPropios"
                            [(ngModel)]="neoPropuestaIntermediarioPropios.propuesta.idParametrizacionLinea" required
                            (change)="cargarDatosLineaPropia($event.target.value)" title="Seleccione una opción">
                            @for (linea of lineasPropias; track linea) {
                              <option [(value)]="linea.idParametrizacionLinea">
                              {{linea.nombreLinea}} - {{linea.nombre}}</option>
                            }
                          </select>
                        </div>
                      </div>
                      <div class="row mt-3 text-start justify-content-md-center">
                        <div class="col-12 col-sm-5">
                          <p>Monto*</p>
                          <div class="input-group">
                            <span class="input-group-text">$</span>
                            <input class="form-control" type="text"
                              onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" maxlength="17"
                              id="montoPropios" (keypress)="setPipeMontoPropios()" name="montoPropios"
                              (blur)="calcularCuota()" [(ngModel)]="montoPropios" required>
                            </div>
                          </div>
                          <div class="col-12 col-sm-2"></div>
                          <div class="mb-3 col-12 col-sm-5">
                            <p>Plazo en meses*</p>
                            <select class="selectpicker" data-live-search="true" data-size="6" data-width="100%" name="plazoPropios"
                              [(ngModel)]="neoPropuestaIntermediarioPropios.propuesta.plazo" required
                              (change)="calcularCuota()" title="Seleccione una opción">
                              <option value="{{0}}" disabled>Seleccione una opción</option>
                              @for (plazoLinea of plazosLineaPropia; track plazoLinea) {
                                <option value="{{plazoLinea}}">
                                {{plazoLinea}}</option>
                              }
                            </select>
                          </div>
                        </div>
                        <div class="row mt-3 text-start justify-content-md-center">
                          <div class="mb-3 col-12 col-sm-12">
                            <p>Tasa EA* @if (errorTasaMax) {
                              <span style="font-size: 15px;">{{ mensajeError}}</span>
                            }</p>
                            <div class="dropdown">
                              <input  type="text" class="form-control" id="inputTasa" name="inputTasa" placeholder="Seleccionar o ingresar manualmente"
                                (change)="calcularCuota()" maxlength="5" (keypress)="validateNumber($event)" (keyup)="validarTasa($event)"
                                [(ngModel)]="neoPropuestaIntermediarioPropios.propuesta.tasa" [ngModelOptions]="{ standalone: true }" (click)="toggleOptions()"
                                      placement="top"
                                      tooltipClass="stylesToll"
                                      (blur)="hideOptions()"
                                      container="body"
                                      [openDelay]="500"
                                      [ngbTooltip]="mensajeTasa">
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" [ngClass]="{'show': optionsVisible}">
                                  @for (tasa of tasasLineaPropia; track tasa) {
                                    <a class="dropdown-item"  (mousedown)="selectOption(tasa, $event)">{{ tasa }} %</a>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mt-3 text-start justify-content-md-center">
                            <div class="mb-3 col-12 col-sm-5">
                              <p>Periodicidad de pagos*</p>
                              <select class="selectpicker" data-live-search="true" data-size="6" data-width="100%" name="periodicidadPropios"
                                [(ngModel)]="neoPropuestaIntermediarioPropios.propuesta.periodicidad" required
                                (change)="calcularCuota()" title="Seleccione una opción">
                                @for (periodicidad of periodicidadesLineaPropia; track periodicidad) {
                                  <option value="{{periodicidad.idTipoPeriodicidad}}"
                                    >{{periodicidad.nombre}}
                                  </option>
                                }
                              </select>
                            </div>
                            <div class="col-12 col-sm-2"></div>
                            <div class="mb-3 col-12 col-sm-5">
                              <p>Período de gracia</p>
                              <select class="selectpicker" data-live-search="true" data-size="6" title="Seleccione una opción" data-width="100%"
                                name="periodoPropios"
                                [(ngModel)]="neoPropuestaIntermediarioPropios.propuesta.periodoGracia" required
                                title="Seleccione una opción">
                                <option value="{{0}}" disabled>Seleccione una opción</option>
                                @for (periodo of periodosGraciaLineaPropia; track periodo) {
                                  <option value="{{periodo}}">
                                  {{periodo}}</option>
                                }
                              </select>
                            </div>
                          </div>
                          <div class="row mt-3 text-center justify-content-md-center">
                            <div class="col-12 col-sm-4 align-self-center">
                              <div class="col-12 col-sm-12 box">
                                <span
                                  class="number-value">{{neoPropuestaIntermediarioPropios.propuesta.desembolsoAproximado
                                | currency:'USD' : 'symbol' : '1.0-0'}}</span>
                                <p>Valor de oferta</p>
                              </div>
                              <div class="col-12 col-sm-12 box">
                                <span class="number-value">{{neoPropuestaIntermediarioPropios.propuesta.cuota |
                                currency:'USD' : 'symbol' : '1.0-0'}}</span>
                                <p>Valor cuota</p>
                              </div>
                              <div class="col-12 col-sm-12 mt-4">
                                <button type="button" class="btn btn-primary" (click)="downloadAll()">Revisar
                                documentación</button>
                                <a id="allFile" style="display: none;"></a>
                              </div>
                            </div>
                            <div class="col-12 col-sm-8">
                              <div class="col-12 col-sm-12">
                                <form action="">
                                  <div class="row justify-content-md-center mt-4">
                                    <h4>OTROS CARGOS Y/O GARANTÍAS</h4>
                                  </div>
                                  <div class="row mt-2">
                                    @if (tiposCondicion.length == 0) {
                                      <div class="col-12 col-sm-5">
                                        Nombre Cargo y/o Garantías
                                        <input type="text" maxlength="100" name="descripcionCargoGarantiaPropiosNuevo"
                                          [(ngModel)]="cargoGarantiasPropiosNuevo.descripcion">
                                        </div>
                                      }
                                      @if (tiposCondicion.length > 0) {
                                        <div class="mb-3 col-12 col-sm-5">
                                          Nombre Cargo y/o Garantías
                                          <select class="selectpicker" data-live-search="true" data-size="6" data-width="100%"
                                            name="descripcionCargoGarantiaPropiosNuevo"
                                            [(ngModel)]="cargoGarantiasPropiosNuevo.idParametrizacionCondicion"
                                            title="Seleccione una opción">
                                            @for (tipoCondicion of tiposCondicion; track tipoCondicion) {
                                              <option [(value)]="tipoCondicion.idParametrizacionCondicion"
                                              >{{tipoCondicion.nombre}}</option>
                                            }
                                          </select>
                                        </div>
                                      }
                                      <div class="col-12 col-sm-3">
                                        Valor
                                        <input type="text"
                                          onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                                          maxlength="17" id="montoGarantiaPropios"
                                          (keypress)="setPipeMontoGarantiaPropios()" name="montoCargoGarantiaPropiosNuevo"
                                          [(ngModel)]="cargoGarantiasPropiosNuevo.monto">
                                        </div>
                                        <div class="mb-3 col-12 col-sm-4">
                                          Tipos de cargos y/o garantías
                                          <select class="selectpicker" data-size="6" data-width="100%"
                                            name="idTipoCargoGarantiaPropiosNuevo"
                                            [(ngModel)]="cargoGarantiasPropiosNuevo.idTipoCargo_NeoTipoCargo"
                                            title="Seleccione una opción">
                                            @for (tipoCargo of tiposCargo; track tipoCargo) {
                                              <option [(value)]="tipoCargo.idTipoCargo">
                                              {{tipoCargo.nombre}}</option>
                                            }
                                          </select>
                                        </div>
                                      </div>
                                      <div class="row justify-content-md-center mt-3">
                                        <div class="col-12 col-sm-6">
                                          <button type="button" class="btn btn-primary"
                                            [disabled]="!habilitarCargosGarantias"
                                            (click)="agregarCargosGarantiasLineaPropia()">Agregar cargos y/o
                                          garantías</button>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                  <div class="row col-12 col-sm-12 mt-4">
                                    <div class="table-responsive">
                                      <table class="table table-striped table-borderless rounded">
                                        <thead class="table_head">
                                          <tr>
                                            <th scope="col" class="no-styles table-header">Nombre de cargos y/o garantías
                                            </th>
                                            <th scope="col" class="no-styles table-header">Valor</th>
                                            <th scope="col" class="no-styles table-header">Tipo de cargo y/o garantías</th>
                                            <th scope="col" class="no-styles table-header">Acción</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          @for (cargoGarantia of cargosGarantiasLineaPropiaConNombre; track cargoGarantia; let i = $index) {
                                            <tr
                                              >
                                              @if (tiposCondicion.length == 0) {
                                                <th scope="row">{{cargoGarantia.descripcion}}
                                                </th>
                                              }
                                              @if (tiposCondicion.length > 0) {
                                                <th scope="row">{{cargoGarantia.descripcion}}
                                                </th>
                                              }
                                              <td>{{cargoGarantia.monto | currency:'USD' : 'symbol' : '1.0-0'}}</td>
                                              <td>{{cargoGarantia.nombreTipoCargo}}</td>
                                              <td><button type="button" class="btn btn-danger"
                                                (click)="borrarCargosGarantiasLineaPropia(i)"><i
                                              class="fas fa-trash-alt"></i></button></td>
                                            </tr>
                                          }
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                  @if (aprobarPropios) {
                                    <div class="col-12 col-sm-12 mt-4" class="text-start justify-content-start"
                                      >
                                      <p>Observaciones</p>
                                      <textarea name="" id="" cols="80" rows="3" name="observaciones"
                                      [(ngModel)]="neoPropuestaIntermediarioPropios.propuesta.observaciones"></textarea>
                                    </div>
                                  }
                                </div>
                              </div>
                            </form>
                          }
                          @if (observacionesAprobadorPropios) {
                            <div class="row justify-content-md-center">
                              <div class="col-12 col-sm-12 mt-4 justify-content-md-center">
                                <p>Observaciones aprobador</p>
                                <textarea name="" id="" [disabled]="true" cols="80" rows="3" name="observaciones"
                                [(ngModel)]="observacionesAprobadorPropios"></textarea>
                              </div>
                            </div>
                          }
                          @if (origenRecursos=='Propios') {
                            <div class="row justify-content-md-center mt-3">
                              @if (!aprobarPropios && detalleSolcitud.observacionAprobadorParaRevisor == null) {
                                <div class="col-12 col-sm-2 mt-4">
                                  <button type="button" class="btn btn-primary" (click)="anterior()">Anterior</button>
                                </div>
                              }
                              @if (aprobarPropios && detalleSolcitud.observacionAprobadorParaRevisor == null) {
                                <div class="col-12 col-sm-2 mt-4">
                                  <button type="button" class="btn btn-primary" (click)="anteriorPropios2()">Anterior</button>
                                </div>
                              }
                              @if (detalleSolcitud.observacionAprobadorParaRevisor != null) {
                                <div class="col-12 col-sm-2 mt-4" >
                                  <button type="button" class="btn btn-primary"(click)="goBack()">Volver</button>
                                </div>
                              }
                              @if (!aprobarPropios) {
                                <div class="col-12 col-sm-2 mt-4">
                                  <button type="button" class="btn btn-primary" (click)="siguientePropios()"
                                  [disabled]="!habilitarCargosGarantias || errorTasaMax">Siguiente</button>
                                </div>
                              }
                              @if (aprobarPropios) {
                                <div class="col-12 col-sm-2 mt-4">
                                  <button type="button" class="btn btn-primary"
                                  (click)="aprobarSolicitudRecPropios()">Aprobar</button>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                      <div class="footer-body"></div>
                    </div>

                    <!-- Modal -->
                    <div class="modal fade text-center" id="aceptarModal" tabindex="-1"
                      aria-labelledby="aceptarModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-body-monto justify-content-md-center">
                            <div class="row">
                              <div class="col-12 col-sm-12 me-3 ms-3">
                                <h3>La oferta ha sido enviada para aprobación correctamente</h3>
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer justify-content-md-center">
                            <button type="button" class="btn btn-primary" (click)="aceptar()">Aceptar</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Modal cargando-->
                    <div class="modal fade text-center" id="cargarModal" tabindex="-1"
                      aria-labelledby="cargarModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-body-monto justify-content-md-center">
                            <div class="row">
                              <div class="col-12 col-sm-12 me-3 ms-3">
                                <h3>Cargando...</h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
